<template>
  <div class="w-full items-center">
    <div class="w-full">
      <div class="router-header flex flex-wrap items-center mb-3">
        <div class="content-area__heading pr-4">
          <!--<h4 class="mb-1">{{ $t("mySkills.ms1") }}</h4>-->
          <!--<div class="mt-2 mb-1">Select one to continue</div>-->
        </div>
      </div>
      
      <div v-if="completed.length === 0 && inProgress.length === 0 && pendingReview.length === 0">
        <div
          class="con-vs-avatar mx-auto my-6 block 80px"
          style="width: 250px; height: 200px; background: white;"
        >
          <div class="">
            <img
              src="@/assets/Illustrations/Ill_History.svg"
              alt=""
              style="color: grey;"
            />
          </div>
        </div>
        <div class="p-6 text-center">
          <div class="truncate t-sd mb-base">
            <h5 class="mb-2" style="color: #079E9A;">
              {{$t('skillDetails.h1')}}
            </h5>
            <span>{{$t('skillDetails.p1')}}</span>
          </div>
        </div>
      </div>
      
      <div v-else class="vs-tabs-div">
        <vs-tabs class="vs-tabs-group" alignment="fixed">
          
          <!-- TAB 1: IN PROGRESS -->
          <vs-tab :label="$t('mySkills.ms5')">
            <div>
              <InProgress :inProgress="inProgress" />
            </div>
          </vs-tab>
          
          <!-- TAB 2: PENDING REVIEW (NEW) -->
          <!-- <vs-tab label="Pending Review"> 
            <div>
              <PendingReview :pendingReview="pendingReview" />
            </div>
          </vs-tab> -->

          <!-- TAB 3: COMPLETED -->
          <vs-tab :label="$t('mySkills.ms6')">
            <div>
              <Completed :completed="completed" />
            </div>
          </vs-tab>
          
        </vs-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import InProgress from "./InProgress";
import Completed from "./Completed.vue";
import PendingReview from "./PendingReview.vue"; // <-- NEW IMPORT

export default {
  name: "MySkills",
  data() {
    return {
      allCompetencies: [],
      CCD: this.$t("addNewSkill.data"),
      completed: [],
      inProgress: [],
      pendingReview: [] // <-- NEW DATA ARRAY
    };
  },
  components: {
    InProgress,
    Completed,
    PendingReview // <-- REGISTER NEW COMPONENT
  },
  methods: {
    addSkill () {
      this.$router.push("add-skill")
    },
    _searchInDataset(dataset, targetId) {
        if (!dataset || !targetId) return null;
        let parts = targetId.split("-");
        for (let key in dataset) {
            if (dataset[key] && dataset[key].competencies) {
                let comps = dataset[key].competencies;
                if (Array.isArray(comps)) {
                    let found = comps.find(c => c.id === targetId);
                    if (found) return found;
                } else {
                    for (let k in comps) {
                        if (comps[k] && comps[k].id === targetId) return comps[k];
                        if (key === parts[0] && k === parts[1]) return comps[k];
                    }
                }
            }
        }
        return null;
    },
    getSkillData(targetId) {
        if (!targetId) return null;

        let parts = targetId.split("-");
        if (parts.length >= 3) {
            targetId = `${parts[0]}-${parts[1]}`;
        }

        let locale = window.$cookies.get('locale') || (this.$i18n && this.$i18n.locale) || 'en';
        if (locale.includes('-')) {
            locale = locale.split('-')[0];
        }

        let patterns = [
            `i18n-${locale}-deep-Data`,
            `i18n-${locale}-pci-Data-Coach`,
            `i18n-${locale}-pci-Data`,
            `i18n-${locale}-peopletree-Data`,
            `i18n-${locale}-Data-DPM`,
            `i18n-${locale}-Data`
        ];

        if (locale !== 'en') {
            patterns = patterns.concat([
                'i18n-en-deep-Data',
                'i18n-en-pci-Data-Coach',
                'i18n-en-pci-Data',
                'i18n-en-peopletree-Data',
                'i18n-en-Data-DPM',
                'i18n-en-Data'
            ]);
        }

        for (let i = 0; i < patterns.length; i++) {
            try {
                const fallbackModule = require(`@/i18n/${patterns[i]}.js`);
                const fallbackData = fallbackModule.default || fallbackModule;
                if (fallbackData && fallbackData.addNewSkill && fallbackData.addNewSkill.data) {
                    let found = this._searchInDataset(fallbackData.addNewSkill.data, targetId);
                    if (found) return found;
                }
            } catch (err) {}
        }

        return this._searchInDataset(this.CCD, targetId);
    }
  },
  async mounted() {
    const usersId = this.$store.state.traineeCoachAssignment.sidebarId;
    
    try {
      const res = await this.$store.dispatch("trainee-competencies/find", { 
        query: { usersId, $sort: { updatedAt: -1 } } 
      });

      for (let i = 0; i < res.data.length; i++) {
        const competencyRecord = res.data[i];
        this.motivationSurvey = 0;

        if (competencyRecord.motivationSurveyDate != null && competencyRecord.progressStatus === 'in_progress') {
          if (new Date() < new Date(competencyRecord.motivationSurveyDate)) {
            this.motivationSurveyDate = competencyRecord.motivationSurveyDate;
            this.motivationSurvey = 1;
          } else if (new Date() > new Date(competencyRecord.motivationSurveyDate)) {
            this.motivationSurveyDate = competencyRecord.motivationSurveyDate;
            const date1 = new Date(this.motivationSurveyDate);
            const date2 = new Date();
            const diffTime = Math.abs(date2 - date1);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            this.coachingOverdueCounter = diffDays;
            this.motivationSurvey = 2;
          }
        }

        const compIdString = competencyRecord.competencyId;
        
        let compDetails = this.getSkillData(compIdString);
        
        if (!compDetails) {
          compDetails = { 
            id: compIdString, 
            comp: competencyRecord.skill_name || competencyRecord.skillName || "Custom Skill", 
            icon: "", 
            wdd: "" 
          };
        }

        let pmTitles = [];
        if (compDetails.progressMeasures) {
          try {
            let pmRes = await this.$store.dispatch("trainee-competencies-prgms/find", { 
              query: { trainee_competencies_id: competencyRecord.id } 
            });
            
            if (pmRes && pmRes.data) {
              pmRes.data.forEach(dbPm => {
                let measureId = dbPm.progress_measure_id || dbPm.progressMeasureId || dbPm.prgms_id || dbPm.id;
                let matchedPm = compDetails.progressMeasures.find(p => p.id === measureId);
                
                if (matchedPm && matchedPm.title) {
                  pmTitles.push(matchedPm.title);
                }
              });
            }
          } catch(err) {
            console.warn("Could not fetch PRGMS for MySkills title formatting");
          }
        }

        let finalCompName = compDetails.comp;
        if (pmTitles.length > 0) {
          finalCompName = `${compDetails.comp} (${pmTitles.join(', ')})`;
        }

        const formattedRecord = {
          i: competencyRecord.id,
          id: compDetails.id,
          comp: finalCompName,
          icon: compDetails.icon,
          wdd: compDetails.wdd,
          motivationSurvey: this.motivationSurvey
        };

        // --- NEW LOGIC TO SORT INTO 3 ARRAYS ---
        if (competencyRecord.progressStatus === "in_progress") {
          this.inProgress.push(formattedRecord);
        }
        else if (competencyRecord.progressStatus === "pending_review") {
          this.pendingReview.push(formattedRecord);
        }
        else if (competencyRecord.progressStatus === "complete") {
          this.completed.push(formattedRecord);
        }
      }
    } catch (err) {
      console.log("could not find trainee competencies", err);
    }
  }
};
</script>

<style scoped>
.con-vs-card >>> .vs-card--content {
  padding: 3px 8px 3px 8px !important;
  margin-bottom: 10px;
}

.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}

::v-deep .vs-tabs-group .vx-card .flex {
    justify-content: flex-start !important;
    text-align: left !important;
}

::v-deep .vs-tabs-group .vx-card .truncate {
    text-align: left !important;
    white-space: normal !important;
    margin-left: 1rem !important;
}

::v-deep .vs-tabs-group .vx-card h5 {
    margin-left: 0 !important;
    text-align: left !important;
    display: flex;
    align-items: center;
}
</style>